// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  GenericApiResponseModuleSubmissionResponse,
  GenericApiResponseSubmission,
  GenericApiResponseUnionGradingNoneType,
  HTTPValidationError,
  LecturerEvaluationUpdateRequest,
  ModuleEvaluationRequest,
} from '../../models';

/**
 * Get module submission with grading information.

This endpoint allows lecturers to retrieve the module submission
with module-level grading information (feedback, grade, scores).
 * @summary Get Module Submission Evaluation
 */
export const getModuleSubmissionEvaluation = (
  userId: string,
  courseId: string,
  moduleId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleSubmissionResponse>> => {
  return axios.get(`/users/${userId}/courses/${courseId}/modules/${moduleId}/evaluation`, options);
};

export const getGetModuleSubmissionEvaluationQueryKey = (userId: string, courseId: string, moduleId: string) => {
  return [`/users/${userId}/courses/${courseId}/modules/${moduleId}/evaluation`] as const;
};

export const getGetModuleSubmissionEvaluationQueryOptions = <
  TData = Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModuleSubmissionEvaluationQueryKey(userId, courseId, moduleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>> = ({ signal }) =>
    getModuleSubmissionEvaluation(userId, courseId, moduleId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(userId && courseId && moduleId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModuleSubmissionEvaluationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>
>;
export type GetModuleSubmissionEvaluationQueryError = AxiosError<HTTPValidationError>;

export function useGetModuleSubmissionEvaluation<
  TData = Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleSubmissionEvaluation<
  TData = Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleSubmissionEvaluation<
  TData = Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Module Submission Evaluation
 */

export function useGetModuleSubmissionEvaluation<
  TData = Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleSubmissionEvaluation>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModuleSubmissionEvaluationQueryOptions(userId, courseId, moduleId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Evaluate and grade a module submission.

This endpoint allows lecturers to:
1. Update task evaluations for multiple tasks at once
2. Add module-level grading
3. Change the submission state to GRADED (only if submit_to_student is True)
4. Save evaluations as drafts without submitting to students (if submit_to_student is False)
 * @summary Evaluate Module Submission
 */
export const evaluateModuleSubmission = (
  userId: string,
  courseId: string,
  moduleId: string,
  moduleEvaluationRequest: ModuleEvaluationRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseUnionGradingNoneType>> => {
  return axios.put(
    `/users/${userId}/courses/${courseId}/modules/${moduleId}/evaluation`,
    moduleEvaluationRequest,
    options,
  );
};

export const getEvaluateModuleSubmissionMutationOptions = <
  TData = Awaited<ReturnType<typeof evaluateModuleSubmission>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; data: ModuleEvaluationRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['evaluateModuleSubmission'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof evaluateModuleSubmission>>,
    { userId: string; courseId: string; moduleId: string; data: ModuleEvaluationRequest }
  > = (props) => {
    const { userId, courseId, moduleId, data } = props ?? {};

    return evaluateModuleSubmission(userId, courseId, moduleId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; data: ModuleEvaluationRequest },
    TContext
  >;
};

export type EvaluateModuleSubmissionMutationResult = NonNullable<Awaited<ReturnType<typeof evaluateModuleSubmission>>>;
export type EvaluateModuleSubmissionMutationBody = ModuleEvaluationRequest;
export type EvaluateModuleSubmissionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Evaluate Module Submission
 */
export const useEvaluateModuleSubmission = <
  TData = Awaited<ReturnType<typeof evaluateModuleSubmission>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; data: ModuleEvaluationRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { userId: string; courseId: string; moduleId: string; data: ModuleEvaluationRequest },
  TContext
> => {
  const mutationOptions = getEvaluateModuleSubmissionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Update evaluation for a submission
 * @summary Upsert Lecturer Evaluation
 */
export const updateEvaluation = (
  userId: string,
  courseId: string,
  moduleId: string,
  taskId: string,
  lecturerEvaluationUpdateRequest: LecturerEvaluationUpdateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseSubmission>> => {
  return axios.put(
    `/users/${userId}/courses/${courseId}/modules/${moduleId}/task/${taskId}/submission`,
    lecturerEvaluationUpdateRequest,
    options,
  );
};

export const getUpdateEvaluationMutationOptions = <
  TData = Awaited<ReturnType<typeof updateEvaluation>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; taskId: string; data: LecturerEvaluationUpdateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateEvaluation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEvaluation>>,
    { userId: string; courseId: string; moduleId: string; taskId: string; data: LecturerEvaluationUpdateRequest }
  > = (props) => {
    const { userId, courseId, moduleId, taskId, data } = props ?? {};

    return updateEvaluation(userId, courseId, moduleId, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; taskId: string; data: LecturerEvaluationUpdateRequest },
    TContext
  >;
};

export type UpdateEvaluationMutationResult = NonNullable<Awaited<ReturnType<typeof updateEvaluation>>>;
export type UpdateEvaluationMutationBody = LecturerEvaluationUpdateRequest;
export type UpdateEvaluationMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Upsert Lecturer Evaluation
 */
export const useUpdateEvaluation = <
  TData = Awaited<ReturnType<typeof updateEvaluation>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string; taskId: string; data: LecturerEvaluationUpdateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { userId: string; courseId: string; moduleId: string; taskId: string; data: LecturerEvaluationUpdateRequest },
  TContext
> => {
  const mutationOptions = getUpdateEvaluationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Regenerate the unsigned module-level AI summary draft for manual grading.
 * @summary Regenerate Module Feedback
 */
export const regenerateModuleFeedback = (
  userId: string,
  courseId: string,
  moduleId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleSubmissionResponse>> => {
  return axios.post(
    `/users/${userId}/courses/${courseId}/modules/${moduleId}/evaluation/regenerate`,
    undefined,
    options,
  );
};

export const getRegenerateModuleFeedbackMutationOptions = <
  TData = Awaited<ReturnType<typeof regenerateModuleFeedback>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['regenerateModuleFeedback'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateModuleFeedback>>,
    { userId: string; courseId: string; moduleId: string }
  > = (props) => {
    const { userId, courseId, moduleId } = props ?? {};

    return regenerateModuleFeedback(userId, courseId, moduleId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; courseId: string; moduleId: string },
    TContext
  >;
};

export type RegenerateModuleFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateModuleFeedback>>>;

export type RegenerateModuleFeedbackMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Regenerate Module Feedback
 */
export const useRegenerateModuleFeedback = <
  TData = Awaited<ReturnType<typeof regenerateModuleFeedback>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; courseId: string; moduleId: string }, TContext> => {
  const mutationOptions = getRegenerateModuleFeedbackMutationOptions(options);

  return useMutation(mutationOptions);
};
